// 直接导出基础地址变量
export const hyperfHost = process.env.NODE_ENV === "development"
  ? "http://127.0.0.1:9501/"
  : "https://qyh-next-server.zhang66.cn/";


// WEBPACK FOOTER //
// ./src/YsyCollections/host/hyperfHost.js